import React from 'react';
import PropTypes from 'prop-types';
import { Typography, IconButton, Box, Tooltip } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import InnerContent from '../../../components/PageStructure/InnerContent/InnerContent';

import PageContent from '../../../components/PageStructure/PageContent/PageContent';
import PageHeader from '../../../components/PageStructure/PageHeader/PageHeader';
import globals from '../../../globals/communityGlobals';
import { actionTypes } from '../Form/NonPatientActivityForm';
import NonPatientActivityForm from '../../../containers/NonPatientActivities/NonPatientActivityFormContainer';
import { doubleActionPrevent } from '../../../utils/helpers';

const locale = globals.getArea('activities');

class NonPatientActivityCreate extends React.Component {
  handleSave = doubleActionPrevent.bind(this)(
    'Save',
    async (details, shedule, address, shouldAssignToday, excludedCliniciansId) => {
      const { submitAction } = this.props;
      // try {
      await submitAction(
        {
          NonPatientActivity: {
            ...details,
            ...shedule,
            ...address,
            ...excludedCliniciansId,
          },
        },
        shouldAssignToday,
      );
    },
    () => {
      const { navigate } = this.props;
      navigate('/NonPatientActivities');
    },
  );

  render() {
    const nonPatientActivityDefault = {
      id: 0,
      name: '',
    };

    const {
      submitAction,
      goBack,
      navigate,
      dismissError,
      failureMessage,
      isAssigning,
      shouldAssignToday,
      orgUnitId,
      selectedDate,
    } = this.props;
    return (
      <PageContent pageTitle={'Create activity'}>
        <div className="flex-page-content content-wrapper">
          {!shouldAssignToday && (
            <PageHeader>
              <Box className="title-section" display="flex" alignItems="center" px={2} py={1}>
                <Box>
                  <Tooltip title={locale.getMsg('back')}>
                    <IconButton
                      className="back-btn"
                      aria-label="back"
                      size="small"
                      color="primary"
                      onClick={() => goBack()}
                    >
                      <ArrowBackIcon fontSize="inherit" />
                    </IconButton>
                  </Tooltip>
                </Box>
                <Box flexGrow={1}>
                  <Typography variant="h3"> {locale.getMsg('createActivity')}</Typography>
                </Box>
              </Box>
            </PageHeader>
          )}
          <InnerContent isBorderless>
            <div className="full-page">
              <NonPatientActivityForm
                nonPatientActivity={nonPatientActivityDefault}
                actionType={actionTypes.create}
                submitAction={submitAction}
                navigate={navigate}
                saveCallback={this.handleSave}
                failureMessage={failureMessage}
                dismissError={dismissError}
                isAssigning={isAssigning}
                shouldAssignToday={shouldAssignToday}
                orgUnitId={orgUnitId}
                selectedDate={selectedDate}
                canSaveFromPlanning={this.props.canSaveFromPlanning}
                getNpaDetails={this.props.getNpaDetails}
                getNpaSchedule={this.props.getNpaSchedule}
                getNpaAddress={this.props.getNpaAddress}
              />
            </div>
          </InnerContent>
        </div>
      </PageContent>
    );
  }
}

NonPatientActivityCreate.defaultProps = {
  isAssigning: false,
  shouldAssignToday: false,
  orgUnitId: null,
  selectedDate: null,
  canSaveFromPlanning: () => {},
  getNpaDetails: () => {},
  getNpaSchedule: () => {},
  getNpaAddress: () => {},
};

NonPatientActivityCreate.propTypes = {
  submitAction: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired,
  dismissError: PropTypes.func.isRequired,
  failureMessage: PropTypes.string.isRequired,
  isAssigning: PropTypes.bool,
  shouldAssignToday: PropTypes.bool,
  orgUnitId: PropTypes.number,
  selectedDate: PropTypes.date,
  canSaveFromPlanning: PropTypes.func,
  getNpaDetails: PropTypes.func,
  getNpaSchedule: PropTypes.func,
  getNpaAddress: PropTypes.func,
};
export default NonPatientActivityCreate;
